export const PRIMARY_CARE = "VPC";
export const MENTAL_HEALTH = "BEHAVHEALTH";
